export default __webpack_public_path__ + "07eef8b101ca939c978a599f508aa955.jpg";